import React, { useEffect, useState, useRef } from 'react';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { EyeIcon, EyeOffIcon, XIcon } from 'lucide-react';
export function RegisterPage() {
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [privacyRead, setPrivacyRead] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [canCloseModal, setCanCloseModal] = useState(false);
  const modalContentRef = useRef<HTMLDivElement>(null);
  const handleInputChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };
  const handleScroll = () => {
    if (modalContentRef.current) {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = modalContentRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      if (isAtBottom) {
        setCanCloseModal(true);
        setPrivacyRead(true);
      }
    }
  };
  const openPrivacyModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowPrivacyModal(true);
    setCanCloseModal(false);
  };
  const closePrivacyModal = () => {
    if (canCloseModal) {
      setShowPrivacyModal(false);
    }
  };
  const handleCheckboxChange = () => {
    if (privacyRead) {
      setPrivacyAccepted(!privacyAccepted);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle registration logic
    console.log('Registration submitted:', formData);
  };
  useEffect(() => {
    if (showPrivacyModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showPrivacyModal]);
  return <main className="min-h-screen bg-[#eff0f2] flex items-center justify-center px-4 py-8" data-id="element-1507">
      <div className="bg-white p-10 w-full max-w-md" style={{
      border: '1px solid #E4E4E4',
      borderRadius: '8px',
      boxShadow: 'none'
    }} data-id="element-1508">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-1509">
          <img src="https://www.perchicrea.it/wp-content/uploads/2021/03/logo-per-chi-crea.png" alt="Per Chi Crea" className="h-12" data-id="element-1510" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-medium text-[#293B54] text-center mb-2 font-['Roboto']" data-id="element-1511">
          Registrati
        </h1>
        <p className="text-[#80858E] text-center mb-8 font-['Roboto']" data-id="element-1512">
          Crea il tuo account per partecipare ai bandi
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1513">
          <Input label="Nome" type="text" value={formData.nome} onChange={handleInputChange('nome')} placeholder="Inserisci il tuo nome" data-id="element-1514" />

          <Input label="Cognome" type="text" value={formData.cognome} onChange={handleInputChange('cognome')} placeholder="Inserisci il tuo cognome" data-id="element-1515" />

          <Input label="Email" type="email" value={formData.email} onChange={handleInputChange('email')} placeholder="Inserisci la tua email" data-id="element-1516" />

          {/* Password with toggle */}
          <div className="relative" data-id="element-1517">
            <Input label="Password" type={showPassword ? 'text' : 'password'} value={formData.password} onChange={handleInputChange('password')} placeholder="Inserisci la password" data-id="element-1518" />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-9 text-[#80858E] hover:text-[#293B54]" aria-label={showPassword ? 'Nascondi password' : 'Mostra password'} data-id="element-1519">
              {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-1520" /> : <EyeIcon className="h-5 w-5" data-id="element-1521" />}
            </button>
          </div>

          {/* Confirm Password with toggle */}
          <div className="relative" data-id="element-1522">
            <Input label="Conferma Password" type={showConfirmPassword ? 'text' : 'password'} value={formData.confirmPassword} onChange={handleInputChange('confirmPassword')} placeholder="Conferma la password" data-id="element-1523" />
            <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-3 top-9 text-[#80858E] hover:text-[#293B54]" aria-label={showConfirmPassword ? 'Nascondi password' : 'Mostra password'} data-id="element-1524">
              {showConfirmPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-1525" /> : <EyeIcon className="h-5 w-5" data-id="element-1526" />}
            </button>
          </div>

          {/* Privacy Policy Checkbox */}
          <div className="flex items-start gap-3 pt-2" data-id="element-1527">
            <input type="checkbox" id="privacy" checked={privacyAccepted} onChange={handleCheckboxChange} disabled={!privacyRead} className="mt-1 h-4 w-4 rounded border-[#E4E4E4] text-[#293B54] focus:ring-[#2A97DF] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1528" />
            <label htmlFor="privacy" className="text-sm text-[#444444] font-['Roboto']" data-id="element-1529">
              Ho letto e accetto la{' '}
              <button type="button" onClick={openPrivacyModal} className="text-[#2A97DF] hover:underline font-medium" data-id="element-1530">
                Privacy Policy
              </button>
            </label>
          </div>

          {/* Submit Button */}
          <Button type="submit" className="w-full mt-6" disabled={!privacyAccepted} data-id="element-1531">
            Registrati
          </Button>
        </form>

        {/* Login Link */}
        <p className="text-center mt-6 text-[#444444] font-['Roboto']" data-id="element-1532">
          Hai già un account?{' '}
          <a href="/login" className="text-[#2A97DF] hover:underline font-medium" data-id="element-1533">
            Accedi
          </a>
        </p>
      </div>

      {/* Privacy Policy Modal */}
      {showPrivacyModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1534">
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50" onClick={canCloseModal ? closePrivacyModal : undefined} data-id="element-1535" />

          {/* Modal */}
          <div className="relative bg-white w-full max-w-2xl max-h-[80vh] flex flex-col shadow-xl" data-id="element-1536">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-[#E4E4E4]" data-id="element-1537">
              <h2 className="text-xl font-medium text-[#293B54] font-['Roboto']" data-id="element-1538">
                Informativa Privacy
              </h2>
              <button type="button" onClick={closePrivacyModal} disabled={!canCloseModal} className="text-[#80858E] hover:text-[#293B54] disabled:opacity-50 disabled:cursor-not-allowed" aria-label="Chiudi" data-id="element-1539">
                <XIcon className="h-6 w-6" data-id="element-1540" />
              </button>
            </div>

            {/* Modal Content - Scrollable */}
            <div ref={modalContentRef} onScroll={handleScroll} className="flex-1 overflow-y-auto p-6 text-[#444444] font-['Roboto'] text-sm leading-relaxed" data-id="element-1541">
              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1542">
                1. Titolare del Trattamento
              </h3>
              <p className="mb-4" data-id="element-1543">
                Il Titolare del trattamento dei dati personali è SIAE - Società
                Italiana degli Autori ed Editori, con sede legale in Viale della
                Letteratura, 30 - 00144 Roma, nella persona del legale
                rappresentante pro tempore.
              </p>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1544">
                2. Responsabile della Protezione dei Dati (DPO)
              </h3>
              <p className="mb-4" data-id="element-1545">
                Il Responsabile della Protezione dei Dati (DPO) può essere
                contattato all'indirizzo email: dpo@siae.it oppure all'indirizzo
                postale della sede legale.
              </p>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1546">
                3. Finalità del Trattamento
              </h3>
              <p className="mb-4" data-id="element-1547">
                I dati personali forniti saranno trattati per le seguenti
                finalità:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1548">
                <li data-id="element-1549">
                  Gestione della registrazione e dell'account utente sulla
                  piattaforma "Per Chi Crea"
                </li>
                <li data-id="element-1550">
                  Gestione delle candidature ai bandi pubblicati sulla
                  piattaforma
                </li>
                <li data-id="element-1551">
                  Comunicazioni relative allo stato delle candidature e agli
                  esiti delle valutazioni
                </li>
                <li data-id="element-1552">Adempimento degli obblighi di legge e regolamentari</li>
                <li data-id="element-1553">Gestione di eventuali contenziosi</li>
              </ul>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1554">
                4. Base Giuridica del Trattamento
              </h3>
              <p className="mb-4" data-id="element-1555">
                Il trattamento dei dati personali è necessario per l'esecuzione
                di un contratto di cui l'interessato è parte o per l'esecuzione
                di misure precontrattuali adottate su richiesta dello stesso
                (art. 6, par. 1, lett. b) del Regolamento UE 2016/679).
              </p>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1556">
                5. Categorie di Dati Trattati
              </h3>
              <p className="mb-4" data-id="element-1557">
                I dati personali oggetto di trattamento sono:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1558">
                <li data-id="element-1559">
                  Dati anagrafici (nome, cognome, codice fiscale, data e luogo
                  di nascita)
                </li>
                <li data-id="element-1560">
                  Dati di contatto (indirizzo email, numero di telefono,
                  indirizzo di residenza)
                </li>
                <li data-id="element-1561">Dati relativi all'attività professionale e artistica</li>
                <li data-id="element-1562">Dati bancari per l'eventuale erogazione di contributi</li>
              </ul>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1563">
                6. Modalità del Trattamento
              </h3>
              <p className="mb-4" data-id="element-1564">
                Il trattamento dei dati personali è realizzato per mezzo delle
                operazioni indicate all'art. 4 n. 2) del GDPR e precisamente:
                raccolta, registrazione, organizzazione, conservazione,
                consultazione, elaborazione, modificazione, selezione,
                estrazione, raffronto, utilizzo, interconnessione, blocco,
                comunicazione, cancellazione e distruzione dei dati.
              </p>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1565">
                7. Periodo di Conservazione
              </h3>
              <p className="mb-4" data-id="element-1566">
                I dati personali saranno conservati per il tempo necessario al
                conseguimento delle finalità per le quali sono raccolti e
                trattati, incluso l'assolvimento di obblighi di legge, contabili
                e fiscali. In particolare, i dati relativi alle candidature
                saranno conservati per un periodo di 10 anni dalla conclusione
                del procedimento.
              </p>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1567">
                8. Destinatari dei Dati
              </h3>
              <p className="mb-4" data-id="element-1568">
                I dati personali potranno essere comunicati a:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1569">
                <li data-id="element-1570">
                  Ministero della Cultura, in qualità di ente finanziatore
                </li>
                <li data-id="element-1571">Commissioni di valutazione delle candidature</li>
                <li data-id="element-1572">Fornitori di servizi informatici e di hosting</li>
                <li data-id="element-1573">Consulenti e professionisti incaricati</li>
                <li data-id="element-1574">Autorità pubbliche, ove richiesto dalla legge</li>
              </ul>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1575">
                9. Diritti dell'Interessato
              </h3>
              <p className="mb-4" data-id="element-1576">L'interessato ha il diritto di:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1577">
                <li data-id="element-1578">Accedere ai propri dati personali</li>
                <li data-id="element-1579">Ottenere la rettifica o la cancellazione degli stessi</li>
                <li data-id="element-1580">Ottenere la limitazione del trattamento</li>
                <li data-id="element-1581">Opporsi al trattamento</li>
                <li data-id="element-1582">Richiedere la portabilità dei dati</li>
                <li data-id="element-1583">Revocare il consenso in qualsiasi momento</li>
                <li data-id="element-1584">
                  Proporre reclamo all'Autorità Garante per la protezione dei
                  dati personali
                </li>
              </ul>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1585">
                10. Conferimento dei Dati
              </h3>
              <p className="mb-4" data-id="element-1586">
                Il conferimento dei dati personali è necessario per la
                registrazione alla piattaforma e per la partecipazione ai bandi.
                Il mancato conferimento comporterà l'impossibilità di procedere
                con la registrazione e con la presentazione delle candidature.
              </p>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1587">
                11. Trasferimento dei Dati
              </h3>
              <p className="mb-4" data-id="element-1588">
                I dati personali sono conservati su server ubicati all'interno
                dell'Unione Europea. Non è previsto il trasferimento dei dati
                verso Paesi terzi.
              </p>

              <h3 className="font-medium text-[#293B54] mb-4" data-id="element-1589">
                12. Processo Decisionale Automatizzato
              </h3>
              <p className="mb-4" data-id="element-1590">
                Non è previsto alcun processo decisionale automatizzato,
                compresa la profilazione, di cui all'art. 22, paragrafi 1 e 4,
                del Regolamento UE 2016/679.
              </p>

              <p className="mt-8 text-[#80858E] italic" data-id="element-1591">
                Ultimo aggiornamento: Gennaio 2025
              </p>
            </div>

            {/* Modal Footer */}
            <div className="p-6 border-t border-[#E4E4E4]" data-id="element-1592">
              {!canCloseModal && <p className="text-sm text-[#80858E] text-center mb-4 font-['Roboto']" data-id="element-1593">
                  Scorri fino in fondo per poter chiudere
                </p>}
              <Button type="button" onClick={closePrivacyModal} disabled={!canCloseModal} className="w-full" data-id="element-1594">
                CHIUDI
              </Button>
            </div>
          </div>
        </div>}
    </main>;
}